/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  // [PROSPEK] 2026-06-11 media quick replies - support reusable attachment IDs.
  files,
  cannedResponseAttachmentIds,
  // [/PROSPEK]
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  isVoiceMessage = false,
}) => {
  let payload;
  // [PROSPEK] 2026-06-11 media quick replies - FormData is also required for reusable attachment IDs.
  const manualFiles = files || [];
  const reusableAttachmentIds = cannedResponseAttachmentIds || [];
  if (manualFiles.length !== 0 || reusableAttachmentIds.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    manualFiles.forEach(file => {
      payload.append('attachments[]', file);
    });
    reusableAttachmentIds.forEach(id => {
      payload.append('canned_response_attachment_ids[]', String(id));
    });
    // [/PROSPEK]
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (isVoiceMessage) {
      payload.append('is_voice_message', true);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    // [PROSPEK] 2026-06-11 media quick replies - reusable canned-response attachment IDs.
    cannedResponseAttachmentIds,
    // [/PROSPEK]
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    isVoiceMessage = false,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        // [PROSPEK] 2026-06-11 media quick replies - reusable canned-response attachment IDs.
        cannedResponseAttachmentIds,
        // [/PROSPEK]
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        isVoiceMessage,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    // [PROSPEK] 2026-06-19 Request timestamp cursor only from dashboard history pagination /
    // 2026-06-23 preserve zero lower-bound cursor for degraded deep-link windows.
    const params = { before, use_created_at_cursor: true };
    const hasAfterCursor =
      after !== undefined && after !== null && after !== '';
    if (hasAfterCursor && Number(after) !== Number(before)) {
      params.after = after;
    }
    // [/PROSPEK]
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }
}

export default new MessageApi();
